<template>
  <div>
    <v-container class="common-page-container">
      <h1>
        Conditions d'utilisation
      </h1>
      <p>
        <nuxt-link to="/en/terms-of-use" rel="nofollow">
          English version
        </nuxt-link>
      </p>
      <h2 class="mt-10">
        SOMMAIRE
      </h2>
      <ul>
        <li>Article 1 : Objet</li>
        <li>Article 2 : Mentions légales</li>
        <li>
          Article 3 : Obligations
          <ul>
            <li>3.1 Obligations de l'utilisateur</li>
            <li>3.2 Règles principales</li>
            <li>3.3 Non respect des conditions générales d'utilisation</li>
          </ul>
        </li>
        <li>
          Article 4 : Confidentialité
          <ul>
            <li>4.1 Protection des données personnelles</li>
            <li>4.2 Droit d'accès aux informations</li>
            <li>4.3 Cookies</li>
          </ul>
        </li>
        <li>
          Article 5 : Propriété intellectuelle
          <ul>
            <li>5.1 Licences de nos contenus</li>
            <li>5.2 Violation du droit d'auteur</li>
            <li>5.3 Conditions découlant de l'interactivité du site</li>
          </ul>
        </li>
        <li>
          Article 6 : Responsabilités
          <ul>
            <li>6.1 Dommages matériels et pertes de données</li>
            <li>6.2 Responsabilité lors de la pratique</li>
            <li>6.3 Recherche de partenaire d'escalade</li>
          </ul>
        </li>
        <li>
          Article 7 : Limitation de garanties
        </li>
        <li>
          Article 8 : Liens hypertextes
          <ul>
            <li>8.1 Liens vers le site Oblyk.org</li>
            <li>8.2 Liens hypertextes en direction de sites tiers</li>
          </ul>
        </li>
        <li>Article 9 : Droit applicable</li>
      </ul>

      <h3>Article 1 : Objet</h3>
      <p>
        Les conditions générales d'utilisation ont pour objet de définir les modalités de mise à disposition des
        services d'<strong>Oblyk.org</strong> par l'utilisateur. Tout accès et utilisation d'<strong>Oblyk.org</strong>
        est soumis au respect de l'ensemble des règles et obligations décrites dans les conditions générales
        d'utilisation, sans aucune restriction.
      </p>
      <p>
        Toute personne (physique ou morale) souhaitant accéder au service d'<strong>Oblyk.org</strong> doit donc avoir
        préalablement lu l'intégralité des conditions générales d'utilisation, se trouvant au pied de chaque page du
        site internet. Il sera donc considéré que par sa seule navigation sur <strong>Oblyk.org</strong>, l'utilisateur
        a intégralement lu et accepté les conditions générales d'utilisation.
      </p>
      <p>
        <strong>Oblyk.org</strong> se réserve le droit de modifier ou de mettre à jour à tout moment ses conditions
        générales d'utilisation.
      </p>

      <h3>Article 2 : Mentions légales</h3>
      <p>
        Selon l'article 6 de la loi n°2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, il est
        précisé aux utilisateurs d'<strong>Oblyk.org</strong> l'identité des propriétaires du site internet, et de
        l'organisme hébergeur du site.
      </p>
      <p class="mb-0">
        <strong>Oblyk.org</strong> est édité par Oblyk SAS.
      </p>
      <p>
        Société par Action Simplifiée au capital de 1000 €. Domicilé au 139 Avenue Maréchal de Saxe 69003, LYON<br>
        SIRET : 98515257800011
      </p>
      <p>
        Le directeur de rédaction d'<strong>Oblyk.org</strong> est Lucien Chastan.
      </p>
      <p>
        Contact : <a href="mailto:ekip@oblyk.org">ekip@oblyk.org</a>
      </p>
      <p class="mb-0">
        <u>Hébergement de l’application et l'API de <strong>Oblyk.org</strong> :</u><br>
        L’application Web de <strong>Oblyk.org</strong> est hébergée par <a href="https://onetsolutions.net/">ONETSOLUTIONS</a>
      </p>
      <p>
        Société par action simplifiée. 1 Allée de l'Ecluse, 33370 YVRAC
      </p>
      <p>
        <u>Hébergement de la documentation de <strong>Oblyk.org</strong> :</u><br>
        La documentation d’<strong>Oblyk.org</strong> est généré et hébergé par <a href="https://github.com/">Github</a>
      </p>
      <p>
        Le traitement informatique des données sur le site <strong>Oblyk.org</strong> se fait dans le respect de la vie
        privée et de la légalité : conformément aux dispositions de la loi n° 78-17 du 6 Janvier 1978 relative a
        l'informatique, aux fichiers et aux libertés, ce site a fait l'objet d'une déclaration auprès de la Commission
        Nationale de l'Informatique et des Libertés (CNIL) : déclaration n°1890811v0.
      </p>

      <h3>Article 3 : Obligations</h3>

      <h4>3.1 Obligations de l'utilisateur</h4>
      <p>
        En acceptant les conditions générales d'utilisation d'<strong>Oblyk.org</strong>, l'utilisateur s'interdit de se
        livrer à des actes de quelque nature que ce soit, tels que l'édition, la mise en ligne, l'émission ou la
        diffusion de contenus, d'informations et de données qui seraient contraires à la loi, ou qui pourraient porter
        atteinte à l'ordre public, aux droits d'<strong>Oblyk.org</strong>, ou aux droits de tiers.
      </p>

      <h4>3.2 Règles principales</h4>
      <p>Par conséquent, l'utilisateur s'engage à respecter les règles suivantes ( liste non-exhaustive ) :</p>
      <ul class="mb-6">
        <li>
          se conformer aux lois en vigueur, respecter les conditions générales d'utilisation, et les droits des tiers
        </li>
        <li>
          ne pas créer, diffuser, transmettre, communiquer ou stocker des informations et données à caractère
          diffamatoire, injurieux, obscène, pornographique, pédopornographique, violent ou incitant à la violence,
          raciste, xénophobe, homophobe, discriminatoire, et plus généralement tout contenu contraire à l'ordre public
        </li>
        <li>
          respecter les droits de propriété intellectuelle liés aux contenus diffusés sur <strong>Oblyk.org</strong>
        </li>
        <li>ne pas détourner une des fonctionnalités d'<strong>Oblyk.org</strong> de son usage normal</li>
        <li>ne pas diffuser de contenus, de données ou d'informations non conformes à la réalité</li>
        <li>
          ne pas diffuser de contenus, de données ou d'informations susceptibles de diminuer, désorganiser ou empêcher
          l'utilisation normale d'<strong>Oblyk.org</strong>.
        </li>
      </ul>

      <h4>3.3 Non respect des conditions générales d'utilisation</h4>
      <p>
        Dans le cas ou les conditions générales du site n'auraient pas été respectées, <strong>Oblyk.org</strong> pourra
        retirer tout ou partie des contenus mis en ligne par les utilisateurs malveillants. Tout utilisateur a le droit
        de signaler un contenu qu'il estime contraire aux conditions générales d'utilisation en contactant les
        administrateurs d'<strong>Obyk.org</strong>.
      </p>

      <h3>Article 4 : Confidentialité</h3>

      <h4>4.1 Protection des données personnelles</h4>
      <p>
        Selon la loi n° 78-87 du 6 janvier 1978, la loi n° 2004-80 du 6 août 2004, l’article L. 226-13 du Code pénal et
        la Directive 95/46/CE du Parlement européen et du Conseil du 24 octobre 1995, les données personnelles des
        utilisateurs recueillies lors de leur inscription sont protégées. Elles font l'objet d'un traitement
        informatique : <strong>Oblyk.org</strong> les utilise uniquement pour que l'utilisateur puisse avoir recours aux
        différents services et fonctionnalités du site. Ces données peuvent également être utilisée par <strong>Oblyk.org</strong>
        à des fins statistiques, pour connaître les données de fréquentation du site, ou pour mieux cibler les nouvelles
        fonctionnalités développées. En aucun cas ces données ne seront transmises à des tiers (particuliers ou
        partenaires commerciaux) : elles restent en la possession d'<strong>Oblyk.org</strong>, qui en garantit la
        confidentialité.
      </p>

      <h4>4.2 Droit d'accès aux informations</h4>
      <p>
        Conformément aux articles 39 et 40 de la Loi n° 78-17 du 6 janvier 1978, l'utilisateur peut choisir à tout
        moment d'accéder à ses informations personnelles détenues par <strong>Oblyk.org</strong>, mais aussi demander
        leur modification ou leur suppression.
      </p>

      <h4>4.3 Cookies</h4>
      <p>
        <strong>Oblyk.org</strong> utilise des cookies, qui sont des marqueurs permettant d'améliorer l'expérience de
        navigation sur le site (sauvegarde de certains paramètres en mémoire sur le navigateur, pour plus de rapidité
        lors de l'utilisation).
      </p>
      <p>
        Les cookies sont anonymes, et ne sont pas utilisés à des fins de collecte d'information à caractère personnel.
        Aucune de ces données anonymes ne pourra être transmise à des partenaires commerciaux, ou organismes tiers :
        elle resteront en possession d'<strong>Oblyk.org</strong>.
      </p>
      <p>
        Pour plus de précision, veuillez consulter la page :
        <nuxt-link to="/fr/cookie-et-mesure-d-audience">
          Cookie & Mesure d'audience
        </nuxt-link>
      </p>

      <h3>Article 5 : Propriété intellectuelle</h3>

      <h4>5.1 Licences de nos contenus</h4>
      <p>
        On distingue deux types de contenus sur <strong>Oblyk.org</strong> : le contenu personnel, et le contenu
        communautaire.
      </p>
      <p>
        Le contenu personnel comprend tout ce que les utilisateurs publient sur leur profil : les voies qu'ils cochent
        dans leur carnet de croix, leurs informations personnelles, leurs photos personnelles, leurs messages
        personnels, leurs contributions sur le forum. Ce contenu est soumis au droit d'auteur, et l'auteur est
        l'utilisateur concerné.
      </p>
      <p>
        Le contenu communautaire comprend les contributions des utilisateurs à <strong>Oblyk.org</strong> : les sites,
        secteurs et lignes qu'ils ajoutent sur la base de données du site (et les informations détaillées qui y sont
        liées), les commentaires (publics ou anonymes), les mots ajoutés au lexique, les liens qu'ils postent, les topos
        qu'ils référencent, les photos qu'ils ajoutent pour la communauté.
      </p>
      <p>
        Le propriétaire du contenu communautaire est ©Oblyk. Ce contenu est sous double licence :
        <a class="lien_mentions" href="https://creativecommons.org/licenses/?lang=fr-FR">CC BY-NC-SA</a>
        (pour le contenu) , et
        <a class="lien_mentions" href="https://opendatacommons.org/licenses/odbl/">Open Database License</a>
        (pour la base de données).
      </p>
      <p>
        Vous êtes libres de remixer, arranger, et adapter notre œuvre à des fins non commerciales, tant que vous
        créditez notre nom et que les œuvres dérivées que vous diffusez sont soumises aux mêmes conditions. Veuillez
        créditez ©Oblyk, indiquer le lien du document source sur
        <a class="lien_mentions" href="https://oblyk.org">oblyk.org</a>
        , et insérer le nom des deux licences (CC BY-NC-SA et Open Database License), ainsi qu'un lien
        hypertexte vers chacune de ces deux licences.
      </p>

      <h4>5.2 Violation du droit d'auteur</h4>
      <p>
        Nous rappelons aux contributeurs d’<strong>Oblyk.org</strong> qu’ils ne doivent jamais ajouter de données
        provenant de sources protégées par le droit d’auteur (copyright) ou des droits voisins sans autorisation
        explicite de la part des détenteurs de ces droits.
      </p>
      <p>
        Si vous pensez que des données ont été ajoutées à la base de données d'<strong>Oblyk.org</strong> en violation
        des droits d’auteur, veuillez nous contacter à <a class="lien_mentions" href="mailto:ekip@oblyk.org">ekip@oblyk.org</a>.
      </p>

      <h4>5.3 Conditions découlant de l'interactivité du site</h4>
      <p>
        En ajoutant un contenu (texte, image, ou autre) dans l'une des rubriques interactives du site, l'utilisateur
        cède expressément et gracieusement à <strong>Oblyk.org</strong> le droit de diffusion de ce contenu
        (reproduction, représentation, adaptation) par tout moyen (tout support et tout format connu et inconnu à ce
        jour) pour le monde entier et pour la durée de propriété intellectuelle actuelle ou à venir. Les droits d'auteur
        restent réservés.
      </p>
      <p>
        <strong>Oblyk.org</strong> se réserve le droit de publier ou non les contributions qu'il reçoit sur le site, de
        les modifier, les adapter, les traduire en toute langue, les conserver ou les supprimer en ligne à tout moment.
      </p>
      <p>
        L'utilisateur est seul et unique responsable du contenu qu'il ajoute sur <strong>Oblyk.org</strong>. À ce titre,
        il garantit <strong>Oblyk.org</strong> contre tout recours et/ou action judiciaire qui pourrait découler de sa
        diffusion. Il répond notamment pénalement et financièrement seul des atteintes éventuelles aux droits de la
        personne, droit à la vie privée, droit à la dignité humaine et droits d'auteur que causerait sa contribution.
      </p>
      <p>
        Les contributions des utilisateurs n'engagent que leur auteur et ne représentent en aucun cas une prise de
        position officielle d'<strong>Oblyk.org</strong>.
      </p>

      <h3>Article 6 : Responsabilités</h3>
      <p>
        L'utilisation d'<strong>Oblyk.org</strong> se fait sous l'entière responsabilité des internautes.
      </p>

      <h4>6.1 Dommages matériels et pertes de données</h4>
      <p>
        Sous réserve des dispositions légales applicables, <strong>Oblyk.org</strong> ne saurait être tenu responsable
        de tout dommage direct ou indirect (comme : perte de profits, de clientèle, de données, de biens incorporels ;
        liste non exhaustive) résultant de l'utilisation ou de l'impossibilité d'utilisation du site, et plus
        généralement de tout évènement ayant un lien avec le site et/ou tout site tiers. Tout matériel ou contenu
        téléchargé sur le site <strong>Oblyk.org</strong> l'est aux risques et périls de l'utilisateur. <strong>Oblyk.org</strong>
        ne saurait être tenu responsable d'éventuels dommages ou pertes de données subis par l'ordinateur d'un
        utilisateur.
      </p>

      <h4>6.2 Responsabilité lors de la pratique</h4>
      <p>
        La pratique des activités sportives de plein air (telles que l'escalade ou d'autres disciplines liées à la
        montagne) doit se faire avec une connaissance avancée du terrain et des techniques de sécurité de l'activité
        concernée, et présente l'acceptation d'un degré de risque qui doit être adapté aux capacités de chacun. <strong>Oblyk.org</strong>
        recommande à ses utilisateurs la plus grande prudence dans l'interprétation des données et informations
        renseignées par la communauté. <strong>Oblyk.org</strong> ne garantit en aucun cas l'exactitude et
        l'exhaustivité des indications fournies directement sur ce site (comme l'équipement des lignes, leur hauteur,
        les conseils présents sur le forum ou dans des commentaires, etc. liste non exhaustive) . Tous ces
        renseignements son non contractuels et ne peuvent donc pas engager la responsabilité
        d'<strong>Oblyk.org</strong> ou des auteurs des contenus en question. De plus, ces renseignements ne peuvent se
        substituer à l'avis d'un professionnel qualifié pour l'activité sportive concernée. <strong>Oblyk.org</strong>
        décline toute responsabilité liée aux incidents de toute nature pouvant intervenir suite à l'utilisation ou
        l'interprétation d'informations diffusées sur son site internet.
      </p>

      <h4>6.3 Recherche de partenaire d'escalade</h4>
      <p>
        <strong>Oblyk.org</strong> ne pourra pas être tenu responsable du comportement ou des actes des personnes qui se
        rencontreraient ou communiqueraient suite à l'utilisation du service de recherche de partenaires.
      </p>
      <p class="red--text">
        Le service de recherche de partenaire est interdit aux mineurs.
      </p>
      <p>
        Pour que le service de recherche de partenaire fonctionne, l'utilisateur doit obligatoirement renseigner sa date
        de naissance. <strong>Oblyk.org</strong> ne pourra pas être tenu responsable dans le cas où l'utilisateur
        indique une fausse date de naissance dans le but d'utiliser le service malgré les restrictions.
      </p>

      <h3>Article 7 : Limitation de garanties</h3>
      <p>
        <strong>Oblyk.org</strong> se réserve la possibilité, à tout moment, d'interrompre temporairement ou
        définitivement tout ou partie de ce site internet, sans préavis ni indemnités. <strong>Oblyk.org</strong> ne
        pourra en aucun cas être tenu responsable des conséquences d'une telle décision.
      </p>

      <h3>Article 8 : Liens hypertextes</h3>

      <h4>8.1 Liens vers le site Oblyk.org</h4>
      <p>
        Les liens pointant sur n'importe quelle page du site (page d'accueil ou autres) sont autorisés et fortement
        encouragés. Cependant, <strong>Oblyk.org</strong> n'exerce aucun contrôle sur les sites tiers et ne peut donc
        assumer aucune responsabilité liée aux contenus, produits, services, informations, matériaux, logiciels des
        sites externes qui comportent un lien hypertexte vers <strong>Oblyk.org</strong>.
      </p>

      <h4>8.2 Liens hypertextes en direction de sites tiers</h4>
      <p>
        <strong>Oblyk.org</strong> peut contenir des liens hypertexte vers des sites tiers, mais n'exerce aucun contrôle
        sur ces sites tiers, et donc ne peut assumer aucune responsabilité liée à la disponibilité de ces sites, ou liée
        aux contenus, publicités, produits, et services disponibles sur ou à partir de ces sites.
        <strong>Oblyk.org</strong> ne pourra pas être tenu responsable des dommages directs ou indirects liés à l'accès
        d'un de ses utilisateurs à un site tiers, ou lié à l'utilisation des services proposés sur ces sites.
      </p>

      <h3>Article 9 : Droit applicable</h3>
      <p>
        Le site <strong>Oblyk.org</strong> est soumis au droit français
      </p>
    </v-container>

    <app-footer />
  </div>
</template>

<script>
import AppFooter from '@/components/layouts/AppFooter'

export default {
  components: { AppFooter },

  head () {
    return {
      title: "Condition d'utilisation",
      meta: [
        { hid: 'robots', name: 'robots', content: 'noindex' },
        { hid: 'description', name: 'description', content: "Voir les conditions générales d'utilisation d'Oblyk, le site communautaire d'escalade : notre politique de confidentialité et nos mentions légales" },
        { hid: 'og:title', property: 'og:title', content: "Condition d'utilisation" },
        { hid: 'og:description', property: 'og:description', content: "Voir les conditions générales d'utilisation d'Oblyk, le site communautaire d'escalade : notre politique de confidentialité et nos mentions légales" },
        { hid: 'og:image', property: 'og:image', content: `${process.env.VUE_APP_OBLYK_APP_URL}/images/oblyk-og-image.jpg` }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  margin-top: 3em;
  margin-bottom: 0.5em;
}

p {
  text-align: justify;
  hyphens: auto;
}
</style>
